import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { ADD_TO_CARTS_FAILURE, ADD_TO_CARTS_SUCCESS, CLEAR_ERRORS, FETCH_CARTS_FAILURE, FETCH_CARTS_SUCCESS, MERGE_CARTS_FAILURE, MERGE_CARTS_SUCCESS, ON_FETCH_FAILURE, ON_FETCH_START, ON_FETCH_SUCCESS } from '@nike/cart-constants';
var warningReducer = function warningReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case ADD_TO_CARTS_FAILURE:
    case ADD_TO_CARTS_SUCCESS:
    case FETCH_CARTS_FAILURE:
    case FETCH_CARTS_SUCCESS:
    case MERGE_CARTS_FAILURE:
    case MERGE_CARTS_SUCCESS:
    case ON_FETCH_FAILURE:
    case ON_FETCH_SUCCESS:
      {
        var _action$payload;
        return [].concat(_toConsumableArray(state), _toConsumableArray((action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.warnings) || []));
      }
    case ON_FETCH_START:
    case CLEAR_ERRORS:
      return [];
    default:
      return state;
  }
};
export default warningReducer;